import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";

const Tile = forwardRef(
  (
    { onGameStart, stopGame, id, tileHeight, logo, gameStoped, increaseScore },
    ref
  ) => {
    const [tilePos, setTilePos] = useState(0);
    const [correctSelected, setCorrectSelected] = useState(false);
    const [gameStarted, setGameStarted] = useState(false);
    const [wrongSelected, setWrongSelected] = useState(-1);

    useEffect(() => {
      let num = Math.floor(Math.random() * 4);
      setTilePos(num);
      setCorrectSelected(false);
    }, []);

    useEffect(() => {
      if (wrongSelected > -1 && !gameStoped) {
        stopGame();
        setGameStarted(false);
        // if (window.confirm("Restart Game?")) {
        //   onResetGame();
        // } else {
        //   console.log("No");
        // }
      }
    }, [wrongSelected]);

    useImperativeHandle(ref, () => ({
      randomPos() {
        let num = Math.floor(Math.random() * 4);
        setTilePos(num);
        setCorrectSelected(false);
        setWrongSelected(-1);
        setGameStarted(false);
      },
      checkTile() {
        if (!correctSelected) {
          stopGame();
          setGameStarted(false);
        }
      },
    }));

    return (
      <div
        id={id}
        style={{
          width: "100%",
          height: tileHeight,
          top: -1 * tileHeight,
          position: "absolute",
          userSelect: "none",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "calc(100vw / 4)",
            border: "2px solid gray",
            position: "absolute",
            left: "0",
            backgroundColor: wrongSelected === 0 ? "#fb4254" : "transparent",
          }}
          onClick={() => {
            if (tilePos !== 0 && !gameStoped) setWrongSelected(0);
          }}
        />

        <div
          style={{
            height: "100%",
            width: "calc(100vw / 4)",
            border: "2px solid gray",
            position: "absolute",
            left: "calc(100vw / 4)",
            backgroundColor: wrongSelected === 1 ? "#fb4254" : "transparent",
          }}
          onClick={() => {
            if (tilePos !== 1 && !gameStoped) setWrongSelected(1);
          }}
        />
        <div
          style={{
            height: "100%",
            width: "calc(100vw / 4)",
            border: "2px solid gray",
            position: "absolute",
            left: "calc(calc(100vw / 4) * 2)",
            backgroundColor: wrongSelected === 2 ? "#fb4254" : "transparent",
          }}
          onClick={() => {
            if (tilePos !== 2 && !gameStoped) setWrongSelected(2);
          }}
        />
        <div
          style={{
            height: "100%",
            width: "calc(100vw / 4)",
            border: "2px solid gray",
            position: "absolute",
            left: "calc(calc(100vw / 4) * 3)",
            backgroundColor: wrongSelected === 3 ? "#fb4254" : "transparent",
          }}
          onClick={() => {
            if (tilePos !== 3 && !gameStoped) setWrongSelected(3);
          }}
        />
        <div
          style={{
            cursor: "pointer",
            height: "calc(100% - 4px)",
            width: "calc(calc(100vw / 4) - 4px)",
            backgroundColor: correctSelected ? "#a6ce39" : "#00aeef",
            position: "absolute",
            left: "calc(calc(calc(100vw / 4) * " + tilePos + ") + 4px)",
            top: "4px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => {
            if (id === "tile5" && !gameStarted) {
              onGameStart();
              setGameStarted(true);
            }
            if (!gameStoped) {
              setCorrectSelected(true);
              increaseScore();
            }
          }}
        >
          <img
            src={logo}
            alt=""
            style={{ height: "60%", width: "60%", objectFit: "contain" }}
          />
          <div
            style={{
              width: "100%",
              height: "100%",
              // backgroundColor: "red",
              position: "absolute",
              left: "0px",
              top: "0px",
            }}
          />
        </div>
      </div>
    );
  }
);
export default Tile;
